<template>
  <div id="product">
    <div class="header flex-between">
      <div class="header-text">
        <h1>可分享产品</h1>
      </div>

      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="tableList(), (tableData = [])"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-notebook-2"
          @click="openAddShow()"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.edit"
          icon="el-icon-edit-outline"
          @click="editShareProduct(), (title = 'GIADA Friends—可分享产品—修改')"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          @click="openDeleteShow()"
          >删除</el-button
        >

        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="openLookShow()"
          >查看</el-button
        >
      </div>
    </div>

    <el-card shadow="never" :body-style="bodyStyle">
      <div style="padding: 15px 0 0 15px">
        <el-form
          label-width="100px"
          :model="queryInfo"
          size="small"
          :inline="true"
        >
          <el-form-item label="产品名称">
            <el-input v-model="queryInfo.productName"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select style="width: 100%" v-model="queryInfo.state">
              <el-option
                v-for="item in effective"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品分类">
            <el-select
              style="width: 100%"
              v-model="queryInfo.topCategoryID"
              @change="selectProductClass"
            >
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in productClassInfo"
                :key="item.shareCategoryID"
                :value="item.shareCategoryID"
                :label="item.categoryName"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一级分类">
            <el-select
              @focus="focus"
              style="width: 100%"
              v-model="queryInfo.subCategoryID"
            >
              <el-option :value="null" label="全部"></el-option>
              <el-option
                v-for="item in PrimaryData"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 选择会员列表 -->
    <div class="amend">
      <el-dialog
        :close-on-click-modal="false"
        width="70%"
        title="选择商品"
        :visible.sync="productListShow"
      >
        <SELECTPRODUCT
          @close="productListShow = false"
          @submit="getChangeProductInfo"
        ></SELECTPRODUCT>
      </el-dialog>
    </div>

    <!--修改、创建弹窗  -->
    <div class="amend">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        :title="title"
        :visible.sync="show"
      >
        <el-form
          style="margin-top: 15px"
          size="mini"
          :label-position="labelPosition"
          label-width="120px"
          :model="formLabelAlign"
          :inline="true"
          :rules="createdRules"
          ref="createRef"
        >
          <el-form-item label="产品编号">
            <el-input
              v-model="formLabelAlign.shareProductCode"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productName">
            <div class="flex-between" @click="productListShow = true">
              <el-input
                v-model="formLabelAlign.productName"
                style="width: 200px"
                readonly
              ></el-input>
              <el-button
                style="
                  border: 1px solid #6e6e6e;
                  color: #4d4d4d;
                  margin-left: 5px;
                "
                size="mini"
                >选择</el-button
              >
            </div>
          </el-form-item>
          <el-form-item label="产品详情">
            <el-input
              type="textarea"
              v-model="formLabelAlign.productDetail"
            ></el-input>
          </el-form-item>
          <el-form-item label="SKC" prop="sku">
            <el-input
              style="width: 100%"
              disabled
              v-model="formLabelAlign.sku"
            ></el-input>
          </el-form-item>
          <el-form-item label="颜色">
            <el-input v-model="formLabelAlign.color"></el-input>
          </el-form-item>
          <el-form-item label="材质">
            <el-input v-model="formLabelAlign.material"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-select v-model="formLabelAlign.isActive" style="width: 100%">
              <el-option
                v-for="item in optionState"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="吊牌价">
            <el-input v-model="formLabelAlign.price"></el-input>
          </el-form-item>

          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">图片信息</span>
          </div>
        </el-form>

        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
          :inline="true"
        >
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="缩略图URL">
              <el-input v-model="formLabelAlign.thumbnailUrl"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.thumbnailUrl"
                :preview-src-list="[formLabelAlign.thumbnailUrl]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片一URL">
              <el-input v-model="formLabelAlign.imageUrl1"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl1"
                :preview-src-list="[formLabelAlign.imageUrl1]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片二URL">
              <el-input v-model="formLabelAlign.imageUrl2"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl2"
                :preview-src-list="[formLabelAlign.imageUrl2]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片三URL">
              <el-input v-model="formLabelAlign.imageUrl3"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl3"
                :preview-src-list="[formLabelAlign.imageUrl3]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片四URL">
              <el-input v-model="formLabelAlign.imageUrl4"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl4"
                :preview-src-list="[formLabelAlign.imageUrl4]"
              ></el-image>
            </el-form-item>
          </div>
        </el-form>
        <div style="height: 20px; background-color: #d3d3d3">
          <span style="font-weight: 700; margin-left: 20px">分类信息</span>
        </div>
        <div style="margin-top: 10px; padding: 0 50px 0 50px">
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
            :inline="true"
          >
            <el-form-item label="产品分类">
              <el-select
                v-model="formLabelAlign.topCategoryID"
                @change="selectProductClass"
              >
                <el-option
                  v-for="item in productClassInfo"
                  :key="item.shareCategoryID"
                  :value="item.shareCategoryID"
                  :label="item.categoryName"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="一级分类">
              <el-transfer
                :titles="['可选项', '已选择']"
                v-model="formLabelAlign.subCategoryIds"
                :data="PrimaryData"
              ></el-transfer>
            </el-form-item>
            <el-form-item label="上新时间">
              <el-date-picker
                v-model="formLabelAlign.releaseDate"
                type="date"
                placeholder="选择上新时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="上新有效期">
              <el-select
                v-model="formLabelAlign.newValidityPeriod"
                style="width: 100%"
              >
                <el-option
                  v-for="item in upNewTime"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="submit()">保 存</el-button>
          <el-button
            @click="
              (show = false),
                (templatei = {}),
                (formLabelAlign = {}),
                (radioxz = ''),
                (PrimaryData = [])
            "
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>

    <!--查看弹窗  -->
    <div class="amend">
      <el-dialog
        :close-on-click-modal="false"
        width="40%"
        title="GIADA Friends—可分享产品—查看"
        :visible.sync="examineVisible"
      >
        <el-form
          style="margin-top: 15px"
          size="mini"
          :label-position="labelPosition"
          label-width="120px"
          :model="formLabelAlign"
          :inline="true"
        >
          <el-form-item label="产品编号">
            <el-input
              v-model="formLabelAlign.shareProductCode"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <div class="flex-between">
              <el-input
                v-model="formLabelAlign.productName"
                style="width: 200px"
                disabled
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item label="SKC">
            <el-input disabled v-model="formLabelAlign.sku"></el-input>
          </el-form-item>
          <el-form-item label="颜色">
            <el-input disabled v-model="formLabelAlign.color"></el-input>
          </el-form-item>
          <el-form-item label="材质">
            <el-input disabled v-model="formLabelAlign.material"></el-input>
          </el-form-item>
          <el-form-item label="是否启用">
            <el-select
              disabled
              v-model="formLabelAlign.isActive"
              style="width: 100%"
            >
              <el-option
                v-for="item in optionState"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="吊牌价">
            <el-input disabled v-model="formLabelAlign.price"></el-input>
          </el-form-item>
          <el-form-item label="产品详情">
            <el-input
              disabled
              type="textarea"
              v-model="formLabelAlign.productDetail"
            ></el-input>
          </el-form-item>

          <el-form-item label="原产品图片">
            <el-image
              style="width: 100px; height: 100px"
              :src="formLabelAlign.originalProductUrl"
              :preview-src-list="[formLabelAlign.originalProductUrl]"
            ></el-image>
          </el-form-item>

          <div style="height: 20px; background-color: #d3d3d3">
            <span style="font-weight: 700; margin-left: 20px">图片信息</span>
          </div>
        </el-form>

        <el-form
          size="mini"
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
          :inline="true"
        >
          <div style="margin-top: 10px; padding: 0 50px 0 50px">
            <el-form-item label="缩略图URL">
              <el-input
                disabled
                v-model="formLabelAlign.thumbnailUrl"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.thumbnailUrl"
                :preview-src-list="[formLabelAlign.thumbnailUrl]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片一URL">
              <el-input disabled v-model="formLabelAlign.imageUrl1"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl1"
                :preview-src-list="[formLabelAlign.imageUrl1]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片二URL">
              <el-input disabled v-model="formLabelAlign.imageUrl2"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl2"
                :preview-src-list="[formLabelAlign.imageUrl2]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片三URL">
              <el-input disabled v-model="formLabelAlign.imageUrl3"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl3"
                :preview-src-list="[formLabelAlign.imageUrl3]"
              ></el-image>
            </el-form-item>
            <el-form-item label="图片四URL">
              <el-input disabled v-model="formLabelAlign.imageUrl4"></el-input>
            </el-form-item>
            <el-form-item>
              <el-image
                style="width: 100px; height: 100px"
                :src="formLabelAlign.imageUrl4"
                :preview-src-list="[formLabelAlign.imageUrl4]"
              ></el-image>
            </el-form-item>
          </div>
        </el-form>
        <div style="height: 20px; background-color: #d3d3d3">
          <span style="font-weight: 700; margin-left: 20px">分类信息</span>
        </div>
        <div style="margin-top: 10px; padding: 0 50px 0 50px">
          <el-form
            size="mini"
            :label-position="labelPosition"
            label-width="100px"
            :model="formLabelAlign"
            :inline="true"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品分类">
                    <el-select
                      disabled
                      v-model="formLabelAlign.topCategoryID"
                      @change="selectProductClass"
                    >
                      <el-option
                        v-for="item in productClassInfo"
                        :key="item.shareCategoryID"
                        :value="item.shareCategoryID"
                        :label="item.categoryName"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <div style="display: flex; margin-left: 30px">
                    <div>一级分类</div>
                    <div
                      style="
                        border: 1px solid #e4e7ed;
                        width: 180px;
                        height: 230px;
                        margin: 0 0 10px 10px;
                        padding: 10px;
                        background: #f5f7fa;
                      "
                    >
                      <div
                        v-for="(item, index) in formLabelAlign.subCategoryNames"
                        :key="index"
                      >
                        <p>{{ item.categoryName }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-form-item label="上新时间">
              <el-date-picker
                disabled
                v-model="formLabelAlign.releaseDate"
                type="date"
                placeholder="选择上新时间"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="上新有效期">
              <el-select
                disabled
                v-model="formLabelAlign.newValidityPeriod"
                style="width: 100%"
              >
                <el-option
                  v-for="item in upNewTime"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <div style="height: 20px; background-color: #d3d3d3">
          <span style="font-weight: 700; margin-left: 20px">系统信息</span>
        </div>

        <div class="buttonInfo">
          <div>
            <div>创建人</div>
            <div>XXXX</div>
          </div>
          <div>
            <div>创建日期</div>
            <div>2020-10-20</div>
          </div>
        </div>
        <div class="buttonInfo">
          <div>
            <div>最后修改人</div>
            <div>XXXX</div>
          </div>
          <div>
            <div>最后修改日期</div>
            <div>2020-10-20</div>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button
            @click="(examineVisible = false), (templatei = {}), (radioxz = '')"
            >取 消</el-button
          >
        </div>
      </el-dialog>
    </div>

    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        :close-on-click-modal="false"
        width="20%"
        title="删除可分享产品确认取消对话框"
        :visible.sync="deleteFormVisible"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要
            <span style="color: #ff0000">删除</span>可分享产品信息?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deleteProduct">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-card shadow="never" class="card-center" style="margin-top: 10px">
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          height="560px"
          v-el-table-infinite-scroll="load"
          v-loading="loading"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column type="index" width="55"></el-table-column>
          <el-table-column label width="30">
            <template slot-scope="scope">
              <el-radio
                :label="scope.$index"
                v-model="radioxz"
                @change.native="getCurrentRow(scope.row)"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="shareProductCode"
            label="产品编号"
          ></el-table-column>
          <el-table-column
            prop="productName"
            label="产品名称"
          ></el-table-column>
          <el-table-column prop="sku" label="SKC"></el-table-column>
          <el-table-column
            prop=" productName_CN"
            label="产品"
          ></el-table-column>
          <el-table-column
            prop="material"
            label="材质"
            width="150"
          ></el-table-column>
          <el-table-column prop="price" label="品牌价"></el-table-column>
          <el-table-column
            prop="parentCategoryName"
            label="产品品类"
          ></el-table-column>
          <el-table-column prop="subCategoryNames" label="一级分类" width="150">
            <template slot-scope="scope">
              <div
                v-for="(item, index) in scope.row.subCategoryNames"
                :key="index"
                style="display: inline-block"
              >
                <span>{{ item.categoryName }}</span>
                <span v-if="index < scope.row.subCategoryNames.length - 1"
                  >、</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="originalProductUrl"
            label="原产品图片"
            width="150"
          >
            <template slot-scope="scope">
              <el-popover placement="right" width="40" trigger="click">
                <el-image
                  :preview-src-list="[scope.row.originalProductUrl]"
                  :src="scope.row.originalProductUrl"
                ></el-image>
                <a href="#" slot="reference">
                  {{ scope.row.originalProductUrl }}
                </a>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="isActive" label="是否启用">
            <template slot-scope="scope">{{
              scope.row.isActive ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column prop="state" label="是否有效">
            <template slot-scope="scope">{{
              scope.row.state ? "无效" : "有效"
            }}</template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="创建人"
          ></el-table-column>
          <el-table-column prop="createTime" label="创建日期" width="150">
            <template slot-scope="scope">{{
              scope.row.createTime | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            prop="updateUserName"
            label="最后修改人"
            width="100"
          ></el-table-column>
          <el-table-column prop="updateTime" label="最后修改日期" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.updateTime">{{
                scope.row.updateTime | dateFormat
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" align="center" min-width="200">
            <template slot-scope="scope">
              <div class="table-button">
                <el-button
                  size="mini"
                  title="查看"
                  icon="iconfont icon-chakan1"
                  @click="openLookShow(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="修改"
                  icon="iconfont icon-xiugai1"
                  @click="editShareProduct(scope.row)"
                ></el-button>
                <el-button
                  size="mini"
                  title="删除"
                  icon="iconfont icon-a-shanchu11"
                  @click="openDeleteShow(scope.row)"
                ></el-button>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <el-alert
          v-if="total <= tableData.length"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        ></el-alert>
      </el-card>
    </div>
  </div>
</template>

<script>
import {
  getShareableList,
  getProductType,
  deleteSharePrdouct,
  upDateSharePrdouct,
  insertSharePrdouct,
  getProductCode,
} from "@/api/friends";
import SELECTPRODUCT from "@/components/changeProudct";
export default {
  components: {
    SELECTPRODUCT,
  },
  name: "centre",
  data() {
    return {
      productListShow: false, //是否打开选择商品列表
      // 是否启用
      optionState: [
        {
          value: false,
          label: "否",
        },
        {
          value: true,
          label: "是",
        },
      ],
      upNewTime: [
        {
          value: null,
          label: "无",
        },
        {
          value: 30,
          label: "30天",
        },
        {
          value: 60,
          label: "60天",
        },
        {
          value: 120,
          label: "120天",
        },
      ], //上新有效期
      effective: [
        {
          value: null,
          label: "全部",
        },
        {
          value: 0,
          label: "有效",
        },
        {
          value: 1,
          label: "无效",
        },
        // 是否有效
      ],
      show: false, //控制弹窗是否弹出
      title: "",
      value: [],
      radioxz: "",
      deleteFormVisible: false,
      examineVisible: false,
      amendVisible: false,
      createVisible: false,
      labelPosition: "right",
      formLabelAlign: {
        subCategoryIds: [],
      },
      tableData: [],
      pageNum: [],

      queryInfo: {
        pageNo: 1,
        pageSize: 20,
        productName: null,
        state: null,
        subCategoryID: null,
        topCategoryID: null,
      },
      total: 0, //总数
      size: 0, //当前页条数
      pageSize: 0,
      productClassInfo: [], //产品分类
      templatei: {},
      PrimaryData: [], //一级产品分类值
      loading: false,
      // 创建form验证规则
      createdRules: {
        sku: [{ required: true, message: "请选择产品", trigger: "blur" }],
        productName: [
          { required: true, message: "请选择产品", trigger: "blur" },
        ],
      },
      bodyStyle: {
        padding: "0px",
      },
      jurisdiction: {
        search: false,
        create: false,
        edit: false,
        delete: false,
        look: false,
      },
    };
  },
  created() {
    this.loading = true;
    this.tableList();
    this.getProductClassInfo();
    let Product = JSON.parse(localStorage.getItem("Product"));

    for (let i = 0; i < Product.length; i++) {
      if (Product[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (Product[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }

      if (Product[i].menuName == "修改") {
        this.jurisdiction.edit = true;
        continue;
      }

      if (Product[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }

      if (Product[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
    }
  },
  computed: {
    onLoading() {
      return this.loading || this.total < this.tableData.length;
    },
  },
  methods: {
    load() {
      setTimeout(() => {
        if (this.total > this.tableData.length) {
          this.queryInfo.pageNo += 1;
          this.tableList();
        }
      }, 1000);
    },
    openAddShow() {
      this.show = true;
      this.title = "GIADA Friends—可分享产品—创建";
      this.PrimaryData = [];
      this.template = {};
      this.formLabelAlign = {};
      this.getCode();
    },
    //获取产品编码
    async getCode() {
      await getProductCode().then((res) => {
        this.$set(this.formLabelAlign, "shareProductCode", res.data);
      });
    },

    //打开查看
    openLookShow(row) {
      this.formLabelAlign.subCategoryIds = [];
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.shareProductID) {
        this.formLabelAlign = this.templatei;
        this.getPrimaryData(this.formLabelAlign.topCategoryID);
        let array = [];
        for (let i = 0; i < this.templatei.subCategoryNames.length; i++) {
          array.push(this.templatei.subCategoryNames[i].shareCategoryID);
        }
        // this.formLabelAlign.subCategoryIds = [12];
        this.$set(this.formLabelAlign, "subCategoryIds", array);

        this.examineVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },

    //修改，创建保存
    submit() {
      let data = {
        color: this.formLabelAlign.color,
        cpyNO: this.formLabelAlign.cpyNO,
        createUserID: this.formLabelAlign.createUserID,
        createUserName: this.formLabelAlign.createUserName,
        imageUrl1: this.formLabelAlign.imageUrl1,
        imageUrl2: this.formLabelAlign.imageUrl2,
        imageUrl3: this.formLabelAlign.imageUrl3,
        imageUrl4: this.formLabelAlign.imageUrl4,
        isActive: this.formLabelAlign.isActive,
        material: this.formLabelAlign.material,
        newValidityPeriod: this.formLabelAlign.newValidityPeriod,
        parentCategoryName: this.formLabelAlign.parentCategoryName,
        price: this.formLabelAlign.price,
        productDetail: this.formLabelAlign.productDetail,
        productName: this.formLabelAlign.productName,
        releaseDate: this.formLabelAlign.releaseDate,
        shareProductCode: this.formLabelAlign.shareProductCode,
        shareProductID: this.formLabelAlign.shareProductID,
        SKU: this.formLabelAlign.sku,
        state: this.formLabelAlign.state,
        subCategoryIds: this.formLabelAlign.subCategoryIds
          ? this.formLabelAlign.subCategoryIds.toString()
          : "",
        thumbnailUrl: this.formLabelAlign.thumbnailUrl,
        topCategoryID: this.formLabelAlign.topCategoryID,
        updateUserID: this.formLabelAlign.updateUserID,
        updateUserName: this.formLabelAlign.updateUserName,
      };

      this.$refs.createRef.validate(async (valid) => {
        if (valid) {
          if (this.title == "GIADA Friends—可分享产品—修改") {
            await upDateSharePrdouct(data).then((res) => {
              if ((res.message == "success")) {
                this.$message.success(res.message);
                this.show = false;
                this.tableData = [];
                this.queryInfo.pageNo = 1;
                this.tableList();
                this.radioxz = "";
                this.templatei = {};
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            await insertSharePrdouct(data).then((res) => {
              if ((res.message == "success")) {
                this.$message.success(res.message);
                this.show = false;
                this.tableData = [];
                this.queryInfo.pageNo = 1;
                this.tableList();
                this.radioxz = "";
                this.templatei = {};
              } else {
                this.$message.error(res.message);
              }
            });
          }
        }
      });
    },
    //修改
    update() {
      // console.log(this.formLabelAlign);
    },
    //判断是否选择产品分类
    focus() {
      if (this.PrimaryData.length == 0) {
        this.$message.info("请先选择产品分类");
      }
    },

    //产品分类触发
    selectProductClass(value) {
      this.queryInfo.subCategoryID = "";
      this.PrimaryData = [];
      this.getPrimaryData(value);
    },
    //获取一级分类选项
    getPrimaryData(parentID) {
      this.PrimaryData = [];
      getProductType({
        parentID: parentID,
      }).then((res) => {
        for (let i = 1; i < res.data.length; i++) {
          this.PrimaryData.push({
            key: res.data[i].shareCategoryID,
            label: res.data[i].categoryName,
          });
        }
      });
    },
    //打开修改
    editShareProduct(row) {
      this.formLabelAlign.subCategoryIds = [];
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.shareProductID) {
        this.show = true;
        this.formLabelAlign = this.templatei;
        this.getPrimaryData(this.formLabelAlign.topCategoryID);
        let array = [];
        for (let i = 0; i < this.templatei.subCategoryNames.length; i++) {
          array.push(this.templatei.subCategoryNames[i].shareCategoryID);
        }
        // this.formLabelAlign.subCategoryIds = [12];
        this.$set(this.formLabelAlign, "subCategoryIds", array);
        console.log(array);
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //打开删除弹窗
    openDeleteShow(row) {
      if (row) {
        this.templatei = row;
      }
      if (this.templatei.shareProductID) {
        this.deleteFormVisible = true;
      } else {
        this.$message.error("请先选中一行数据");
      }
    },
    //删除分享产品
    deleteProduct() {
      deleteSharePrdouct({
        shareProductID: this.templatei.shareProductID,
      }).then((res) => {
        console.log(res);
        if ((res.message == "success")) {
          this.$message.success(res.message);
          this.deleteFormVisible = false;
          this.tableData = [];
          this.queryInfo.pageNo = 1;
          this.tableList();
          this.radioxz = "";
          this.templatei = {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取选择产品返回数据
    getChangeProductInfo(data) {
      // this.formLabelAlign.shareProductCode = data.SKU;
      this.formLabelAlign.productName = data.productName_CN;
      this.formLabelAlign.sku = data.sku;

      this.productListShow = false;
    },
    //获取产品分类
    getProductClassInfo() {
      getProductType({
        parentID: 0,
      }).then((res) => {
        this.productClassInfo = res.data;
      });
    },
    getCurrentRow(row) {
      this.templatei = row;

      this.formLabelAlign = this.templatei;
    },
    async tableList() {
      this.loading = true;
      await getShareableList(this.queryInfo).then((res) => {
        this.tableData = this.tableData.concat(res.data.list);
        this.pageNum = res.data.pageNum;
        this.pageSize = res.data.size;
        this.total = res.data.total;
        this.size = res.data.size;
        this.loading = false;
      });
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonInfo {
  display: flex;
  justify-content: space-between;
  margin: 10px 100px;
}
.buttonInfo > div {
  display: flex;
  width: 35%;
}
.buttonInfo > div > div:first-child {
  margin-right: 10px;
}
#product {
}
.header {
  .header-text {
    width: 300px;
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
  .card-pagination {
    height: 50px;
  }
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
.xuan .el-button {
  color: #4d4d4d;
}

// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .el-tabs__item {
    width: 42%;
    font-size: 12px !important;
  }
  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
  .create {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  .examine {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }

    .el-form-item__content {
      line-height: 0px;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      height: 44px;
      background: #f3f1dd;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
